// Simplified service worker registration for CRA
// This registers a service worker in production for offline caching.

const isLocalhost = Boolean(
	window.location.hostname === 'localhost' ||
	window.location.hostname === '[::1]' ||
	window.location.hostname.match(
		/^127(?:\.(?:25[0-5]|2[0-4]\d|[01]?\d\d?)){3}$/
	)
);

export function register() {
	if ('serviceWorker' in navigator) {
		const swUrl = '/service-worker.js';
		window.addEventListener('load', () => {
			if (isLocalhost) {
				checkValidServiceWorker(swUrl);
			} else {
				registerValidSW(swUrl);
			}
		});
	}
}

function registerValidSW(swUrl: string) {
	navigator.serviceWorker
		.register(swUrl)
		.then(() => {
			// Registered
		})
		.catch(() => {
			// Ignore
		});
}

function checkValidServiceWorker(swUrl: string) {
	fetch(swUrl)
		.then((response) => {
			const contentType = response.headers.get('content-type');
			if (
				response.status === 404 ||
				(contentType != null && contentType.indexOf('javascript') === -1)
			) {
				navigator.serviceWorker.ready.then((registration) => {
					registration.unregister();
					window.location.reload();
				});
			} else {
				registerValidSW(swUrl);
			}
		})
		.catch(() => {
			// Offline or no SW; do nothing
		});
}

export function unregister() {
	if ('serviceWorker' in navigator) {
		navigator.serviceWorker.ready
			.then((registration) => {
				registration.unregister();
			})
			.catch(() => {});
	}
}

